export default "__VITE_ASSET__Boxm5KE___"